@if (editMode) {
  <div>
    <div class="field title-selection">
      <label>{{ 'COMMUNICATIONS.TITLE' | translate }}</label>
      <div>
        <input
          (ngModelChange)="titleChanged($event)"
          class="input is-small is-fullwidth"
          type="text"
          placeholder="{{ 'COMMUNICATIONS.TITLE' | translate }}"
          [(ngModel)]="title" />
      </div>
    </div>
    <div
      class="upload-edit-control"
      (click)="onUploadClick()"
    style="
      margin: 4px;
      border: 3px dashed var(--neutral-color-400);
      background-color: var(--neutral-color-100);
      cursor: pointer;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      height: 100px;
    ">
      <div style="margin-right: 0.5rem">
        <i
          class="icon icon-cloud_upload"
        style="font-size: 24px"></i>
      </div>
      <div>{{ 'COMMUNICATIONS.DESIGNER.ELEMENTS.IMAGE-UPLOAD' | translate }}</div>
      <input
        #fileUpload
        class="upload-file-control"
        type="file"
        accept="image/*" 
        (change)="fileControlChanged($event)"
        style="display: none" />
    </div>
  </div>
}
@if (!editMode) {
  <div>
    @if (title) {
      <div
        class="title">
        {{ title }}
      </div>
    }
    <div>
      <img
        #image
        class="image-control"
        [src]="imageSource"/>
    </div>
    <input
      #fileUpload
      class="upload-file-control"
      type="file"
      accept="image/*" 
      (change)="fileControlChanged($event)"
      style="display: none" />
  </div>
}
